export default __webpack_public_path__ + "static/media/6.7dfb61e4.svg";